import React from 'react'
import Landing from './components/Landing';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <div>
      <Landing />
      </div>
 
    </>
  );
}

export default App;
